import React from 'react';
var TableContext = /*#__PURE__*/React.createContext(null);
var TableContextProvider = TableContext.Provider;
var TableContextContextConsumer = TableContext.Consumer;
export { TableContext, TableContextContextConsumer, TableContextProvider };